import React from "react";
import Image from "../image/Image.tsx";

const MembershipTitle = ({
  isRaindropPlusship,
  showTitle = true,
  isSmallTitle = false,
}) => {
  var titleTextSize = "text-xl";
  var title = "The Emerald Version";
  var iconUrl =
    "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/icon-version-v1-emerald.png";

  if (isRaindropPlusship) {
    title = "Raindrop Plus";
    iconUrl =
      "https://s3-raindrop-public.s3.eu-west-2.amazonaws.com/icon-version-v1-sapphire.png";
  }

  if (isSmallTitle) {
    titleTextSize = "text-md";
  }

  return (
    <div className="flex flex-row gap-2 items-center">
      <Image src={iconUrl} className="w-10 h-10 rounded-lg" />
      {showTitle && (
        <div className="flex flex-col justify-start items-start w-full">
          <div className={`font-bold whitespace-nowrap ${titleTextSize}`}>
            {title}
          </div>
        </div>
      )}
    </div>
  );
};

export default MembershipTitle;
